module.exports = __webpack_public_path__ + "static/media/empy-placholder-image.7482e1e9.png";